module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 10
// module chunks = 4 5 7 8 9 10 13 15 17 19 20 21 22 23 26 32 34 36 37 43 44 45